<template>
  <Modal v-model="model" sticky reset-drag-position :title="title" @on-cancel="cancel" footer-hide scrollable :mask="false" draggable class="insert_edit_pop"  width="800">
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">分配策略:</div>
        <div class="insert_edit_input">
          <Select v-model="shareStyle">
            <Option v-for="(option, index) in shareStyleList" :value="option.id" :key="index">{{option.name}}</Option>
          </Select>
        </div>
      </div>
      <div class="input_style insert_edit_left">
        <div class="font_style_set">分配客户数:</div>
        <div class="insert_edit_input">
          <Input v-model="shareCustomerCount" :readonly="readonly" placeholder="请输入呼出计划名称"/>
        </div>
      </div>
    </div>
    <div class="insert_edit_template">
      <div class="input_style insert_edit_left">
        <div class="font_style_set">员工工号:</div>
        <div class="insert_edit_input" style="width: 40%">
          <Input v-model="employeeCode" placeholder="请输入员工工号"/>
        </div>
        <Button type="primary" class="submit_btn" @click="initSearch()" style="margin-left: 20px;margin-top: 6px;border-radius: 1px;">查询</Button>
      </div>
    </div>
    <div class="fixed_table">
      <div class="table_head">
        <table>
          <tr>
            <th class="font_style_set" style="width:10%;">
              <Checkbox v-model="checkedAll"  @on-change="checkedAllList()"></Checkbox>
            </th>
            <th class="font_style_set" style="width:10%;">序号</th>
            <th class="font_style_set" style="width:20%;">员工编号</th>
            <th class="font_style_set" style="width:30%;">员工姓名</th>
            <th class="font_style_set" style="width:20%;">员工工号</th>
            <th class="font_style_set" style="width:10%;" v-if="shareStyle=='1'">分配个数</th>
          </tr>
        </table>
      </div>
      <div class="footer_style" style="height: 300px">
        <table class="table_head_footer">
          <tr v-for="(item , index) in infoTableList" :key="index" :id="item.id" :class="{back_color:(index+1)%2==0}">
            <td  style="width:10%;">
              <CheckboxGroup v-model="singleCheckedList"><Checkbox :label="item.id"></Checkbox></CheckboxGroup>
            </td>
            <td  style="width:10%;">{{index+1}}</td>
            <td  style="width:20%;">{{item.employeeCode}}</td>
            <td  style="width:30%;">{{item.employeeName}}</td>
            <td  style="width:20%;">{{item.agentNumber}}</td>
            <td  style="width:10%;" v-if="shareStyle=='1'"><input placeholder="请输入分配的客户数" value="0" :name="item.id" class="share_input" ref="shareValue"/></td>
          </tr>
        </table>
      </div>
    </div>
    <div class="btn_template">
      <Button type="error"   class="cancel_btn" @click="cancel()">取消</Button>
      <Button type="primary" class="submit_btn" @click="onOk()">确认</Button>
    </div>
  </Modal>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
    export default {
        name: "AssignStaffPop",
      mixins:[publicFunClass],
      props: {
        showAssignPop:Boolean,
        checkIds:Array,
        callId:String,
      },
      data(){
        return {
          model:false,
          readonly:true,
          checkedAll: false,
          shareStyle:'0',
          count:0,
          shareStyleList:[{'id':'0','name':'平均分配'},{'id':'1','name':'指定数量分配'}],
          shareCustomerCount:0,
          employeeCode:'',
          title:"手动呼出计划分配客户",
          singleCheckedList: [],
          infoTableList:[],
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
        }
      },
      methods:{
        cancel:function(){
          this.$emit("closeShowAssignPop",false);
        },
        onOk:function(){
          let content="是否确定分配";
          let that=this;
          if(this.singleCheckedList.length==0){
            that.$Modal.info({
              title:'提示',
              content:"请选择座席"
            });
            return false;
          }
          let empIdList=this.singleCheckedList;
          this.count=0;
          if(this.shareStyle=='1'){
            for (let i=0;i<this.infoTableList.length;i++){
              let name=this.$refs.shareValue[i].name;
              let value=this.$refs.shareValue[i].value;
              for (let k=0;k<empIdList.length;k++){
                let id=empIdList[k];
                if(id.indexOf("-")>-1){
                  id=id.split("-");
                  id=id[0];
                }
                if(name==id){
                  this.count=this.count+parseInt(value);
                  empIdList[k]=id+"-"+value;
                }
              }
            }
          }
          if(parseInt(this.shareCustomerCount)<this.count){
            this.$Modal.info({
              title:'提示',
              content:"分配客户数不能超过"+that.shareCustomerCount
            });
            return false;
          }
          let param={
            allotType:this.shareStyle,
            empId:empIdList.toString(),
            taskId: this.callId,
            journalType:"呼出管理=>呼出任务=>分配员工",
            menuId:"2_2-3"
          };
          this.$Modal.confirm({
            title: '提示',
            content: content,
            onOk: () => {
              that.$http.post("calltask/allotCallTask.json",param) .then(function (res) {
                let result=res.data.flag;
                if(result!="666"){
                  that.$alert(res.data.msg, '提示', {
                    confirmButtonText: '确定'
                  });
                  return false;
                }
                that.$Message.info("分配成功");
                that.$emit("closeShowAssignPop",true);
              })
            }
          });
        },
        initSearch:function () {
          let that=this;
          let param={
            agentNumber:this.employeeCode,
            journalType:"null",
            menuId:"null",
            employeeType:'0',
          };
          this.$http.post("employee/selectAllEmp.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.infoTableList=res.data.obj.list.content;
          })
        },
        searchCount:function () {
          let that=this;
          let param={
            taskId:this.callId,
            journalType:"null",
            menuId:"null"
          }
          this.$http.post("calltask/allowAllotCount.json",param) .then(function (res) {
            let result=res.data.flag;
            if(result!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.shareCustomerCount=res.data.obj;
          });
        }
      },
      watch:{
        showAssignPop:function () {
          this.model=this.showAssignPop;
          this.title="手动呼出计划分配客户";
          if(this.showAssignPop){
            this.searchCount();
            this.shareStyle="0";
            this.employeeCode="";
            this.initSearch();
            this.singleCheckedList=[];
            this.checkedAll=false;
          }
        }
      }
    }
</script>

<style scoped>
  .share_input{
    width: 100%;
    text-align: center;
    border: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/callManage/AssignStaffPop.vue